import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { AuthorComponent } from './components/author.component'

import { ClubsDomainModule } from '@alliance/clubs/domain'
import { ClubsUtilsModule } from '@alliance/clubs/utils'

import { SharedPipesBypassSanitizerModule } from '@alliance/shared/pipes/bypass-sanitizer'

const ClubsModules = [ClubsDomainModule, ClubsUtilsModule]

const SharedModules = [SharedPipesBypassSanitizerModule]

@NgModule({
  imports: [CommonModule, ...ClubsModules, ...SharedModules],
  declarations: [AuthorComponent],
  exports: [AuthorComponent]
})
export class ClubsPostAuthorModule {}
